import { render, staticRenderFns } from "./commonRecordsTab.vue?vue&type=template&id=c0efb3de&scoped=true"
import script from "./commonRecordsTab.vue?vue&type=script&lang=js"
export * from "./commonRecordsTab.vue?vue&type=script&lang=js"
import style0 from "./commonRecordsTab.vue?vue&type=style&index=0&id=c0efb3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0efb3de",
  null
  
)

export default component.exports